class CollectionLoadMore {
  constructor() {
    this.init();
  }

  init() {
    this.loadMoreButton = document.querySelector('[data-load-more]');
    this.productsGrid = document.querySelector('[data-products-grid]');
    this.paginationContainer = document.querySelector('.pagination-custom');
    this.currentPage = 1;
    this.isLoading = false;
    this.hasMorePages = true;

    if (this.loadMoreButton) {
      this.loadMoreButton.addEventListener('click', () => this.loadMore());
      this.checkForMoreProducts();
    }

    document.addEventListener('theme:filter:updated', () => {
      this.reset();
    });

    // Listen for pagination clicks
    if (this.paginationContainer) {
      this.paginationContainer.addEventListener('click', (e) => {
        const paginationLink = e.target.closest('a[data-filter-update-url]');
        if (paginationLink) {
          e.preventDefault();
          const url = new URL(paginationLink.href);
          const page = url.searchParams.get('page');
          if (page) {
            this.handlePaginationClick(parseInt(page));
          }
        }
      });
    }
    const url = new URL(window.location.href);
    const page = url.searchParams.get('page');
    if (page) {
      this.currentPage = parseInt(page);
      this.checkForMoreProducts();
    }
  }

  handlePaginationClick(page) {
    if (this.isLoading) return;
    
    this.isLoading = true;
    const url = new URL(window.location.href);
    url.searchParams.set('page', page);
    url.searchParams.delete('phcursor');
    fetch(url)
      .then(response => response.text())
      .then(html => {
        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = html;

        const newProducts = tempContainer.querySelector('.collection-js-grid').innerHTML;
        const productsGrid = this.productsGrid.querySelector('.collection-js-grid');
        productsGrid.innerHTML = newProducts;

        const newPagination = tempContainer.querySelector('.pagination-custom');
        if (newPagination && this.paginationContainer) {
          this.paginationContainer.innerHTML = newPagination.innerHTML;
        }
      
        this.currentPage = page;
        const totalPages = parseInt(newPagination.querySelector('[data-total-pages]').getAttribute('data-total-pages'));
        this.hasMorePages = page < totalPages;

       
        if (this.loadMoreButton) {
          this.loadMoreButton.disabled = !this.hasMorePages;
          this.loadMoreButton.classList.toggle('disabled', !this.hasMorePages);
          this.loadMoreButton.style.display = this.hasMorePages ? 'block' : 'none';
        }

        document.dispatchEvent(new CustomEvent('theme:products:added', {
          bubbles: true
        }));
      })
      .catch(error => {
        console.error('Error loading page:', error);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  checkForMoreProducts() {
    const productsCount = this.productsGrid.querySelectorAll('.product-grid-item').length;
    const totalProducts = parseInt(document.querySelector('[data-products-count]')?.textContent.match(/\d+/)?.[0] || '0');
    
    if (productsCount >= totalProducts) {
      this.hasMorePages = false;
      this.loadMoreButton.disabled = true;
      this.loadMoreButton.classList.add('disabled');
    }
  }

  reset() {
    // Reset state
    this.currentPage = 1;
    this.isLoading = false;
    this.hasMorePages = true;

    // Reinitialize elements
    this.loadMoreButton = document.querySelector('[data-load-more]');
    this.productsGrid = document.querySelector('[data-products-grid]');
    this.paginationContainer = document.querySelector('.pagination-custom');

    // Rebind click event
    if (this.loadMoreButton) {
      this.loadMoreButton.removeEventListener('click', () => this.loadMore());
      this.loadMoreButton.addEventListener('click', () => this.loadMore());
      this.loadMoreButton.disabled = false;
      this.loadMoreButton.classList.remove('disabled', 'is-loading');
      this.loadMoreButton.textContent = 'Load more';
      this.checkForMoreProducts();
    }
  }

  async loadMore() {
    if (this.isLoading || !this.hasMorePages) return;

    this.isLoading = true;
    this.loadMoreButton.classList.add('is-loading');
    this.loadMoreButton.textContent = 'Loading...';
    this.loadMoreButton.disabled = true;

    try {
      const nextPage = this.currentPage + 1;
      const url = new URL(window.location.href);
      url.searchParams.set('page', nextPage);
      url.searchParams.delete('phcursor');
      const response = await fetch(url);
      const html = await response.text();

      // Create a temporary container to parse the HTML
      const tempContainer = document.createElement('div');
      tempContainer.innerHTML = html;

      // Get the products from the response
     
      const newProducts = tempContainer.querySelector('.collection-js-grid').innerHTML;
  
      // Check if there are any new products
      if (!newProducts.trim()) {
        this.hasMorePages = false;
        this.loadMoreButton.disabled = true;
        this.loadMoreButton.classList.add('disabled');
        return;
      }
      
      // Append new products to the grid
 
      const productsGrid = this.productsGrid.querySelector('.collection-js-grid');
     
      productsGrid.insertAdjacentHTML('beforeend', newProducts);
      setTimeout(() => {
        yotpoWidgetsContainer.initWidgets()
      }, 300);
      // Update pagination
      const newPagination = tempContainer.querySelector('.pagination-custom');
 
      if (newPagination && this.paginationContainer) {
        this.paginationContainer.innerHTML = newPagination.innerHTML;
      }


      // Update current page and check if we've reached the end
      this.currentPage = nextPage;
      const totalPages = parseInt(newPagination.querySelector('[data-total-pages]').getAttribute('data-total-pages'));
      this.hasMorePages = nextPage < totalPages;

      // Disable load more button if we've reached the last page
      if (!this.hasMorePages) {
        this.loadMoreButton.disabled = true;
        this.loadMoreButton.classList.add('disabled');
      }

      // Dispatch event for any components that need to know about new products
      document.dispatchEvent(new CustomEvent('theme:products:added', {
        bubbles: true
      }));

    } catch (error) {
      console.error('Error loading more products:', error);
    } finally {
      this.isLoading = false;
      this.loadMoreButton.classList.remove('is-loading');
      this.loadMoreButton.textContent = 'Load more';
      if (this.hasMorePages) {
        this.loadMoreButton.disabled = false;
      }
    }
  }
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  new CollectionLoadMore();
});